import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { CredentialStoreGenericType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { CredentialStoresService } from '@services';
import UiValidators, { CREDENTIAL_STORES_NAME_MAX_LENGTH } from '@validators';
import { BehaviorSubject, iif, of, Subject, } from 'rxjs';
import { finalize, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { DynamicConfigurationFormService } from '../dynamic-configuration-form';
var CredentialStoreControl;
(function (CredentialStoreControl) {
    CredentialStoreControl["type"] = "type";
    CredentialStoreControl["name"] = "name";
    CredentialStoreControl["additionalConfiguration"] = "additionalConfiguration";
})(CredentialStoreControl || (CredentialStoreControl = {}));
var SecureCredentialStoreControl;
(function (SecureCredentialStoreControl) {
    SecureCredentialStoreControl["safe"] = "safe";
    SecureCredentialStoreControl["folder"] = "folder";
    SecureCredentialStoreControl["applicationId"] = "applicationId";
})(SecureCredentialStoreControl || (SecureCredentialStoreControl = {}));
var CredentialStoreModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CredentialStoreModalComponent, _super);
    function CredentialStoreModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CredentialStoreControl = CredentialStoreControl;
        _this.SecureCredentialStoreControl = SecureCredentialStoreControl;
        _this.CredentialStoreGenericType = CredentialStoreGenericType;
        _this.loading$ = new BehaviorSubject(false);
        _this.loadingData$ = new BehaviorSubject(false);
        _this.loadingDynamicForm$ = new BehaviorSubject(false);
        _this.storeTypeDropdownEntries = [];
        _this._formBuilder = _this._injector.get(FormBuilder);
        _this._credentialStoreService = _this._injector.get(CredentialStoresService);
        _this._dynamicConfigurationFormService = _this._injector.get(DynamicConfigurationFormService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._destroyed$ = new Subject();
        return _this;
    }
    Object.defineProperty(CredentialStoreModalComponent.prototype, "_defaultFormGroupConfig", {
        get: function () {
            var _a;
            return _a = {},
                _a[CredentialStoreControl.type] = [],
                _a[CredentialStoreControl.name] = [
                    this._defaultModel.name,
                    Validators.compose([
                        UiValidators.required({
                            allowWhitespace: false,
                        }),
                        Validators.maxLength(CREDENTIAL_STORES_NAME_MAX_LENGTH),
                    ]),
                ],
                _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CredentialStoreModalComponent.prototype, "_formValue", {
        get: function () {
            return tslib_1.__assign({}, this.form.value, { name: this.form.get('name').value.trim(), id: this._defaultModel.id, type: {
                    value: this.selectedType.id,
                    genericType: this.selectedType.data,
                } });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CredentialStoreModalComponent.prototype, "additionalConfigurationFormGroup", {
        get: function () {
            return this.form.get(CredentialStoreControl.additionalConfiguration);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CredentialStoreModalComponent.prototype, "selectedType", {
        get: function () {
            var selected = this.form.get(CredentialStoreControl.type).value[0];
            return selected;
        },
        enumerable: true,
        configurable: true
    });
    CredentialStoreModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadingData$.next(true);
        this.orchestratorDatabaseName = this._translateService.instant('credential_stores_orchestrator_database');
        this._defaultModel = !this.context.isNewEntry ?
            this.context.data : {
            additionalConfiguration: {},
        };
        this.form = this._formBuilder.group(this._defaultFormGroupConfig);
        this.form
            .get(CredentialStoreControl.type)
            .valueChanges
            .pipe(tap(function () { return _this.loadingDynamicForm$.next(true); }), switchMap(function (_a) {
            var _b = _a[0], data = _b.data, id = _b.id;
            if (data === CredentialStoreGenericType.Database) {
                return of(null);
            }
            return _this._credentialStoreService
                .getSecureCredentialStoreConfiguration(id);
        }))
            .subscribe(function (value) {
            _this._updateFormFields(value);
            _this.loadingDynamicForm$.next(false);
        });
        iif(function () { return _this.context.isNewEntry; }, this._credentialStoreService.getCredentialStoreTypes(), of(null)).pipe(finalize(function () { return _this.loadingData$.next(false); })).subscribe(function (credentialStoreTypes) {
            var storeTypeToDropdownEntry = function (storeType) { return ({
                id: storeType.value,
                text: storeType.value,
                data: storeType.genericType,
            }); };
            if (!credentialStoreTypes) {
                var storeType = storeTypeToDropdownEntry(_this.context.data.type);
                _this.storeTypeDropdownEntries = [storeType];
                _this.form.get(CredentialStoreControl.type).setValue([storeType]);
                return;
            }
            _this.storeTypeDropdownEntries = credentialStoreTypes
                .map(storeTypeToDropdownEntry);
            var firstAvailableStore = _this.storeTypeDropdownEntries[0];
            _this.form.get(CredentialStoreControl.type).setValue([firstAvailableStore]);
        });
    };
    CredentialStoreModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    CredentialStoreModalComponent.prototype.onSubmit = function () {
        var _this = this;
        this.loading$.next(true);
        iif(function () { return _this.context.isNewEntry; }, this._credentialStoreService.add(this._formValue), this._credentialStoreService.update(this._defaultModel.id, this._formValue)).pipe(finalize(function () { return _this.loading$.next(false); }), takeUntil(this._destroyed$)).subscribe(function () {
            _this._dialogRef.close({
                type: 4 /* Succeeded */,
            });
        });
    };
    /**
     *
     * @param secureStoreConfiguration its null when the form type is a db form.
     */
    CredentialStoreModalComponent.prototype._updateFormFields = function (secureStoreConfiguration) {
        this.form.removeControl(CredentialStoreControl.additionalConfiguration);
        this.secureStoreConfiguration = [];
        if (secureStoreConfiguration === null) {
            this.form.get(CredentialStoreControl.name).setValue(this.orchestratorDatabaseName);
        }
        else {
            this.secureStoreConfiguration = secureStoreConfiguration;
            var dynamicFormConfiguration = this._dynamicConfigurationFormService.toFormGroup(this.secureStoreConfiguration, this._defaultModel.additionalConfiguration);
            this.form.addControl(CredentialStoreControl.additionalConfiguration, dynamicFormConfiguration);
            this.form.get(CredentialStoreControl.name).setValue(this._defaultModel.name);
        }
    };
    return CredentialStoreModalComponent;
}(UiModalComponent));
export { CredentialStoreModalComponent };
